module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN MEMORIAM"), _c('br'), _vm._v(" ALAN HENRY WOOD"), _c('br'), _vm._v(" \n1941–2003")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45269f59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429910415_ded01.vue
// module id = 66
// module chunks = 0